import Make from './make'

const make = Make('user/')

export const logout = (): void => {
  make.destroyToken()
  window.location.reload()
}
